/* eslint-disable react/prop-types */
import { Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type MobilityApplicationEntrypointSpecsFragment } from '../../../../../api/fragments/MobilityApplicationEntrypointSpecs';
import {
    CreateMobilityApplicationEntrypointDocument,
    type CreateMobilityApplicationEntrypointMutation,
    type CreateMobilityApplicationEntrypointMutationVariables,
} from '../../../../../api/mutations/createMobilityApplicationEntrypoint';
import {
    UpdateMobilityApplicationEntrypointDocument,
    type UpdateMobilityApplicationEntrypointMutation,
    type UpdateMobilityApplicationEntrypointMutationVariables,
} from '../../../../../api/mutations/updateMobilityApplicationEntrypoint';
import { type MobilityApplicationEntrypointSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import { type EndpointImplementation } from './types';

const implementation: EndpointImplementation<
    MobilityApplicationEntrypointSpecsFragment,
    MobilityApplicationEntrypointSettings & { mobilityApplicationModuleId?: string }
> = {
    getTitle: t => t('routerDetails:endpoints.MobilityApplicationEntrypoint.title'),
    ViewPanelComponent: ({ endpoint }) => (
        <Descriptions size="small" bordered>
            <Descriptions.Item label="Module">{endpoint.mobilityApplicationModule.displayName}</Descriptions.Item>
            <Descriptions.Item label="Display Name">{endpoint.displayName}</Descriptions.Item>
        </Descriptions>
    ),
    getIsPrivate: () => true,
    FormComponent: () => {
        const { t } = useTranslation(['routerDetails']);

        return (
            <>
                <InputField
                    {...t('routerDetails:endpoints.fields.pathname', { returnObjects: true })}
                    name="pathname"
                />
                <InputField
                    {...t('routerDetails:endpoints.fields.displayName', { returnObjects: true })}
                    name="displayName"
                />
            </>
        );
    },
    getFormInitialValues: endpoint => ({
        pathname: endpoint.pathname,
        displayName: endpoint.displayName,
    }),
    submitCreation: (apolloClient, routerId, { mobilityApplicationModuleId, ...values }) => {
        if (!mobilityApplicationModuleId) {
            throw new Error('Mobility application module is required');
        }

        return apolloClient.mutate<
            CreateMobilityApplicationEntrypointMutation,
            CreateMobilityApplicationEntrypointMutationVariables
        >({
            mutation: CreateMobilityApplicationEntrypointDocument,
            variables: { routerId, mobilityApplicationModuleId, settings: values },
        });
    },
    submitUpdate: (apolloClient, routerId, endpointId, values) =>
        apolloClient.mutate<
            UpdateMobilityApplicationEntrypointMutation,
            UpdateMobilityApplicationEntrypointMutationVariables
        >({
            mutation: UpdateMobilityApplicationEntrypointDocument,
            variables: { routerId, endpointId, settings: values },
        }),
};

export default implementation;
